import { useCallback, useMemo } from "react";
import { useCategories } from "./useCategories";

/**
 * Resolves a category id to the label the category picker shows
 * ("Phones / Smartphones"), so lists that only carry `categoryId` read the
 * same as the form. Shares the cached `categories` request with the picker.
 */
export function useCategoryLabels() {
  const { data: categories } = useCategories();

  const labelById = useMemo(
    () =>
      new Map(
        (categories ?? []).map((c) => [c.id, c.completeName ?? c.displayName ?? c.name]),
      ),
    [categories],
  );

  return useCallback(
    (id: number | null | undefined) => (id != null ? labelById.get(id) : undefined),
    [labelById],
  );
}
